import { SuppliersTableActionsCell } from '../elements/SuppliersTableActionsCell'
import { SuppliersTableCountryCell } from '../elements/SuppliersTableCountryCell'
import { SuppliersTableEmailCell } from '../elements/SuppliersTableEmailCell'
import { SuppliersTableNameCell } from '../elements/SuppliersTableNameCell'
import { SuppliersTablePhoneCell } from '../elements/SuppliersTablePhoneCell'
import { SuppliersTableColumn } from '../types/suppliersTableColumn'
import { suppliersTableColumnHeaderLocaleKeys } from './suppliersTableColumnHeaderLocaleKeys'

export const suppliersTableColumnDefinitions = [
  {
    key: 'name',
    header: suppliersTableColumnHeaderLocaleKeys.name,
    sortable: true,
    cell: (row) => <SuppliersTableNameCell row={row} />,
  },
  {
    key: 'email',
    header: suppliersTableColumnHeaderLocaleKeys.email,
    hideable: true,
    cell: (row) => <SuppliersTableEmailCell row={row} />,
  },
  {
    key: 'phone',
    header: suppliersTableColumnHeaderLocaleKeys.phone,
    hideable: true,
    cell: (row) => <SuppliersTablePhoneCell row={row} />,
  },
  {
    key: 'country',
    header: suppliersTableColumnHeaderLocaleKeys.country,
    hideable: true,
    cell: (row) => <SuppliersTableCountryCell row={row} />,
  },
  {
    key: 'actions',
    header: null,
    cell: (row) => <SuppliersTableActionsCell row={row} />,
    type: 'action',
  },
] as const satisfies readonly SuppliersTableColumn[]
